'use client';

import clsx from 'clsx';
import { SportIcon, FilterLiveIcon } from '@/components/icons/svg-icons';
import { useParams } from 'next/navigation';
import { MenuItems } from '@/hooks/query';
import { useMenuEditSection } from '../../contexts/menu-edit-section-context';
import { useStreamingStore } from '@/store/streaming';
import { useLocale } from 'next-intl';
import { useRouter } from '@/navigation';
import { sportMenuStyle } from '../../sports-menu.style';
import { menuIconStyle } from '@/components/icons/menu-icon/menu-icon.style';
import { cx, css } from 'styled-system/css';
import { isNumberGames, isVirtualSports } from '@/services/settings.service';
import { useAnalyseAttribute } from '@/features/next-analyse';
import { TimeSensitiveNewTag } from '@/features/new-tag';
import { MouseEventHandler } from 'react';
import { catcherAnalyseService } from '@/services/catcher-analyse.service';
import { useAppearanceStore } from '@/store/appearance';
import { ViewEnum } from '@/types';

export interface SportsOrderItemProps {
	menuList: MenuItems[]
};

const SportItem = ({ menuItem, handleSelect }: {menuItem: MenuItems, handleSelect: (href: string) => MouseEventHandler | undefined}) => {
	const { sport } = useParams();
	const view = useAppearanceStore(state => state.view);
	const nextAnalyseKey = catcherAnalyseService.createTopMenuCatcherKey(menuItem.gameId);
	const taggedElement = useAnalyseAttribute(nextAnalyseKey);

	return (
		<button
			className={clsx('sports-order__item', sportMenuStyle.sportsOrder_item)}
			data-selected={menuItem.icon === sport}
			onClick={handleSelect(menuItem.href)}
			ref={taggedElement}
		>
			<div className={menuIconStyle.menuIcon}>
				<SportIcon sportId={menuItem.icon} isColorful={(view === ViewEnum.galaxy) || (menuItem.icon === sport)} />
				<div className={cx(
					menuIconStyle.menuLiveIcon,
					sportMenuStyle.menuLiveIcon,
					css({ display: { _mars: menuItem.hasLive ? 'block' : 'none' } })
				)}
				>
					<FilterLiveIcon />
				</div>
			</div>
			<div className={clsx('sports-order__label', sportMenuStyle.sportsOrder_label)}>
				{menuItem.name}
			</div>
			{['177', '198'].includes(menuItem.gameId) ? <TimeSensitiveNewTag /> : null}
		</button>
	)
};
export const SportsOrderItem = ({ menuList }: SportsOrderItemProps) => {
	const {
		setIsMenuOpen,
	} = useMenuEditSection();
	const [setStreamingStatus] = useStreamingStore(
		state => [state.setStreamingStatus],
	);
	const { sport } = useParams();
	const router = useRouter();
	const locale = useLocale();

	const handleSelect = (href: string) => () => {
		router.push(href, { locale });
		setStreamingStatus('', '', []);
		setIsMenuOpen(false);
	};


	return (
		(
			menuList.
				filter(item => {
					const isVirtualSportMenu = isVirtualSports(Number(item.gameId));
					const isNumberGameMenu = isNumberGames(Number(item.gameId));
					const isOutright = item.gameId === '999';
					if (isVirtualSports(Number(sport))) {
						return isVirtualSportMenu || item.isVirtualTournament;
					} else if (isNumberGames(Number(sport))) {
						return isNumberGameMenu;
					}
					return !isVirtualSportMenu && !isNumberGameMenu && !isOutright;
				}).map(menuItem => (
					<SportItem
						key={menuItem.icon}
						menuItem={menuItem}
						handleSelect={handleSelect}
					/>
				))
		)
	);
};